var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCollapseLeft(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 13.732c-1.333-.77-2-1.155-2-1.732 0-.578.667-.962 2-1.732l3-1.732c1.333-.77 2-1.155 2.5-.866.5.288.5 1.058.5 2.598v3.464c0 1.54 0 2.31-.5 2.598-.5.289-1.167-.096-2.5-.866l-3-1.732z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseLeft);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkgMTMuNzMxOUM3LjY2NjY3IDEyLjk2MjEgNyAxMi41NzcyIDcgMTEuOTk5OUM3IDExLjQyMjUgNy42NjY2NyAxMS4wMzc2IDkgMTAuMjY3OEwxMiA4LjUzNTc5QzEzLjMzMzMgNy43NjU5OSAxNCA3LjM4MTA5IDE0LjUgNy42Njk3N0MxNSA3Ljk1ODQ0IDE1IDguNzI4MjQgMTUgMTAuMjY3OFYxMy43MzE5QzE1IDE1LjI3MTUgMTUgMTYuMDQxMyAxNC41IDE2LjMzQzE0IDE2LjYxODcgMTMuMzMzMyAxNi4yMzM4IDEyIDE1LjQ2NEw5IDEzLjczMTlaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };